import React, { useState } from "react";
import {
  FaArrowLeft, FaPhone, FaEnvelope, FaCalendarAlt, FaClock,
  FaCheckCircle, FaTimesCircle, FaEdit, FaBan, FaTrash,
  FaCheck, FaTimes, FaStar, FaMoneyBillWave, FaShoppingBag,
  FaShieldAlt, FaHistory, FaImages, FaUserCircle,
} from "react-icons/fa";

/* ═══════════════════════════════════════════════════════
   REBRAND — Raleway · Yellow #fff000 · Black · White
═══════════════════════════════════════════════════════ */
const S = `
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700;800;900&display=swap');

  .cd-wrap * { box-sizing: border-box; font-family: 'Raleway', sans-serif; }

  .cd-back {
    display: inline-flex; align-items: center; gap: 8px;
    background: none; border: none; color: #999;
    font-size: .84rem; font-weight: 600; cursor: pointer;
    margin-bottom: 1.25rem; padding: 4px 0; transition: color .15s;
  }
  .cd-back:hover { color: #fff000; }

  /* Header */
  .cd-header {
    background: #0d0d0d; border: 1px solid rgba(255,255,255,.1);
    border-radius: 16px; padding: 1.5rem; margin-bottom: 1.25rem;
    display: flex; justify-content: space-between; align-items: flex-start;
    gap: 1.5rem; flex-wrap: wrap;
  }
  .cd-header-left { display: flex; gap: 1rem; align-items: center; flex-wrap: wrap; }
  .cd-avatar {
    width: 64px; height: 64px; border-radius: 50%;
    object-fit: cover; border: 3px solid rgba(255,240,0,.35); flex-shrink: 0;
  }
  .cd-avatar-fallback {
    width: 64px; height: 64px; border-radius: 50%;
    background: #fff000; display: flex; align-items: center; justify-content: center;
    font-weight: 900; font-size: 1.5rem; color: #000000; flex-shrink: 0;
  }
  .cd-name { font-size: 1.3rem; font-weight: 800; color: #ffffff; margin-bottom: 6px; }
  .cd-meta-row { display: flex; gap: 16px; flex-wrap: wrap; font-size: .82rem; color: #999; }
  .cd-meta-item { display: flex; align-items: center; gap: 6px; }

  .cd-status-badge {
    display: inline-flex; align-items: center; gap: 6px;
    border-radius: 20px; padding: 5px 14px;
    font-size: .74rem; font-weight: 700; margin-bottom: 8px;
  }
  .cd-status-pending    { background: rgba(255,240,0,.12); color: #fff000; border: 1px solid rgba(255,240,0,.3); }
  .cd-status-active     { background: rgba(255,255,255,.1); color: #ffffff; border: 1px solid rgba(255,255,255,.25); }
  .cd-status-inactive   { background: rgba(255,255,255,.05); color: #888; border: 1px solid rgba(255,255,255,.12); }
  .cd-status-suspended  { background: rgba(255,255,255,.05); color: #cccccc; border: 1px solid rgba(255,255,255,.15); }
  .cd-status-rejected   { background: rgba(255,255,255,.04); color: #666; border: 1px solid rgba(255,255,255,.08); }

  .cd-header-actions { display: flex; gap: 8px; flex-wrap: wrap; }
  .cd-btn {
    display: inline-flex; align-items: center; gap: 7px;
    padding: 9px 16px; border-radius: 9px;
    font-size: .82rem; font-weight: 700; cursor: pointer;
    border: 1px solid; transition: all .15s; white-space: nowrap;
  }
  .cd-btn-approve   { background: #fff000; border-color: #fff000; color: #000000; }
  .cd-btn-approve:hover { background: #e6d900; }
  .cd-btn-reject    { background: rgba(255,255,255,.05); border-color: rgba(255,255,255,.18); color: #ffffff; }
  .cd-btn-reject:hover { background: rgba(255,255,255,.1); }
  .cd-btn-edit      { background: rgba(255,240,0,.08); border-color: rgba(255,240,0,.3); color: #fff000; }
  .cd-btn-edit:hover { background: rgba(255,240,0,.16); }
  .cd-btn-suspend   { background: rgba(255,255,255,.05); border-color: rgba(255,255,255,.18); color: #cccccc; }
  .cd-btn-suspend:hover { background: rgba(255,255,255,.1); color: #fff; }
  .cd-btn-delete    { background: rgba(255,255,255,.03); border-color: rgba(255,255,255,.14); color: #999; }
  .cd-btn-delete:hover { background: rgba(255,255,255,.08); color: #fff; }

  /* Pending: completion + missing requirements */
  .cd-completion-card {
    background: #0d0d0d; border: 1px solid rgba(255,240,0,.2);
    border-radius: 16px; padding: 1.375rem; margin-bottom: 1.25rem;
  }
  .cd-completion-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem; }
  .cd-completion-title { font-size: .95rem; font-weight: 800; color: #ffffff; }
  .cd-completion-pct { font-size: 1.6rem; font-weight: 900; color: #fff000; }
  .cd-completion-track { height: 8px; background: rgba(255,255,255,.08); border-radius: 4px; overflow: hidden; margin-bottom: 1.25rem; }
  .cd-completion-fill { height: 100%; background: #fff000; border-radius: 4px; transition: width .4s ease; }

  .cd-req-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 8px; margin-bottom: 1rem; }
  .cd-req-item { display: flex; align-items: center; gap: 8px; font-size: .84rem; padding: 6px 0; }
  .cd-req-item.ok   { color: #cccccc; }
  .cd-req-item.miss { color: #fff000; font-weight: 600; }

  .cd-reason-box {
    background: rgba(255,240,0,.06); border: 1px solid rgba(255,240,0,.2);
    border-radius: 10px; padding: .875rem 1.125rem;
  }
  .cd-reason-title { font-size: .68rem; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: #fff000; margin-bottom: 6px; }
  .cd-reason-item { font-size: .82rem; color: #e6d900; padding: 2px 0; }

  /* Tabs */
  .cd-tabs { display: flex; gap: 4px; background: #0d0d0d; border: 1px solid rgba(255,255,255,.08); border-radius: 12px; padding: 4px; margin-bottom: 1.25rem; width: fit-content; flex-wrap: wrap; }
  .cd-tab { padding: .55rem 1.1rem; background: none; border: none; border-radius: 9px; font-size: .82rem; font-weight: 600; color: #888; cursor: pointer; transition: all .15s; display: flex; align-items: center; gap: 7px; }
  .cd-tab.on { background: rgba(255,240,0,.12); color: #fff000; }

  .cd-panel { background: #0d0d0d; border: 1px solid rgba(255,255,255,.1); border-radius: 16px; padding: 1.5rem; }

  .cd-field-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 1.25rem; }
  .cd-field-label { font-size: .68rem; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: #888; margin-bottom: 5px; }
  .cd-field-val { font-size: .92rem; color: #ffffff; font-weight: 500; }

  .cd-bio { font-size: .88rem; color: #cccccc; line-height: 1.7; grid-column: 1 / -1; }

  .cd-service-chip {
    display: inline-flex; align-items: center; background: rgba(255,240,0,.08);
    border: 1px solid rgba(255,240,0,.2); color: #fff000; border-radius: 20px;
    padding: 4px 12px; font-size: .8rem; font-weight: 600; margin: 3px 6px 3px 0;
  }

  .cd-gallery { display: grid; grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 10px; }
  .cd-gallery img { width: 100%; height: 140px; object-fit: cover; border-radius: 10px; border: 1px solid rgba(255,255,255,.1); }
  .cd-gallery-empty { text-align: center; padding: 3rem; color: #666; font-size: .88rem; }

  .cd-stat-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; }
  .cd-stat { background: #141414; border: 1px solid rgba(255,255,255,.08); border-radius: 12px; padding: 1.1rem; }
  .cd-stat-icon { width: 34px; height: 34px; border-radius: 9px; background: rgba(255,240,0,.1); color: #fff000; display: flex; align-items: center; justify-content: center; font-size: .85rem; margin-bottom: 10px; }
  .cd-stat-val { font-size: 1.4rem; font-weight: 800; color: #ffffff; }
  .cd-stat-lbl { font-size: .72rem; color: #888; margin-top: 3px; }

  .cd-verif-row { display: flex; justify-content: space-between; align-items: center; padding: .75rem 0; border-bottom: 1px solid rgba(255,255,255,.06); }
  .cd-verif-row:last-child { border-bottom: none; }
  .cd-verif-key { font-size: .84rem; color: #999; }
  .cd-verif-val { font-size: .86rem; font-weight: 600; color: #ffffff; }

  .cd-notes-box { margin-top: 1rem; }
  .cd-notes-textarea {
    width: 100%; background: #000000; border: 1.5px solid rgba(255,255,255,.12);
    border-radius: 9px; padding: .75rem 1rem; color: #ffffff;
    font-family: 'Raleway', sans-serif; font-size: .86rem; outline: none;
    resize: vertical; min-height: 80px; transition: border-color .2s;
  }
  .cd-notes-textarea:focus { border-color: #fff000; }

  .cd-timeline { display: flex; flex-direction: column; gap: 0; }
  .cd-timeline-item { display: flex; gap: 14px; padding: .875rem 0; border-bottom: 1px solid rgba(255,255,255,.06); }
  .cd-timeline-item:last-child { border-bottom: none; }
  .cd-timeline-dot { width: 30px; height: 30px; border-radius: 50%; background: rgba(255,240,0,.1); color: #fff000; display: flex; align-items: center; justify-content: center; font-size: .8rem; flex-shrink: 0; }
  .cd-timeline-label { font-size: .86rem; color: #ffffff; font-weight: 500; }
  .cd-timeline-time { font-size: .74rem; color: #777; margin-top: 2px; }
  .cd-timeline-empty { text-align: center; padding: 2.5rem; color: #666; font-size: .86rem; }
`;

const TOTAL_CRITERIA = 6;

function timeSince(dateStr) {
  if (!dateStr) return null;
  const diff  = Date.now() - new Date(dateStr).getTime();
  const mins  = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days  = Math.floor(diff / 86400000);
  if (mins < 2)   return "Just now";
  if (mins < 60)  return `${mins}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days === 1) return "Yesterday";
  if (days < 7)   return `${days}d ago`;
  return new Date(dateStr).toLocaleDateString("en-KE", { day: "numeric", month: "short", year: "numeric" });
}

/**
 * The control center. Reached from CraftsmenTable's "View" button.
 * Everything that used to crowd the table lives here instead:
 * profile completion + missing requirements (pending only), full profile,
 * portfolio gallery, marketplace stats, verification info, and an
 * activity timeline.
 */
export default function CraftsmanDetailView({
  craftsman,
  isPending = false,
  getImageUrl,
  checkCraftsmanApprovalCriteria,
  isCraftsmanApproved,
  onBack,
  onApprove,
  onReject,
  onEdit,
  onSuspend,
  onDelete,
  onSaveNotes,
}) {
  const [tab, setTab] = useState("profile");
  const [notes, setNotes] = useState(craftsman.admin_notes || "");
  const [savingNotes, setSavingNotes] = useState(false);

  if (!craftsman) return null;

  const errors = checkCraftsmanApprovalCriteria(craftsman);
  const hasIssues = errors.length > 0;
  const completionPct = Math.round(((TOTAL_CRITERIA - errors.length) / TOTAL_CRITERIA) * 100);
  const imgSrc = getImageUrl(craftsman.profile);
  const getInitial = (name) => (name || "?").charAt(0).toUpperCase();

  const approved = isCraftsmanApproved(craftsman);
  const statusLabel = isPending
    ? "Pending"
    : !approved
      ? "Rejected"
      : craftsman.is_suspended
        ? "Suspended"
        : craftsman.is_active
          ? "Active"
          : "Inactive";
  const statusClass = `cd-status-${statusLabel.toLowerCase()}`;

  const REQUIREMENTS = [
    { key: "full_name",       label: "Full Name",     ok: !!craftsman.full_name?.trim() },
    { key: "phone",           label: "Phone Number",  ok: !!(craftsman.phone || craftsman.phone_number) },
    { key: "primary_service", label: "Service Selected", ok: !!(craftsman.primary_service?.trim() || craftsman.services?.[0]?.name) },
    { key: "description",     label: "Bio",           ok: !!craftsman.description?.trim() },
    { key: "gallery",         label: "Work Sample",   ok: Array.isArray(craftsman.gallery_images) && craftsman.gallery_images.length > 0 },
    { key: "proof_document",  label: "ID Verification", ok: !!craftsman.proof_document },
  ];

  const galleryImages = (craftsman.gallery_images || craftsman.portfolio_images || [])
    .map(f => (typeof f === "string" ? f : f.image_url || f.url || f.image))
    .filter(Boolean);

  const services = craftsman.services?.length
    ? craftsman.services.map(s => s.name || s.service_name).filter(Boolean)
    : craftsman.primary_service ? [craftsman.primary_service] : [];

  const activity = craftsman.activity_log || [
    craftsman.date_joined && { label: "Registered account", time: craftsman.date_joined, icon: <FaUserCircle /> },
    galleryImages.length > 0 && { label: "Uploaded work sample", time: craftsman.updated_at, icon: <FaImages /> },
    craftsman.approved_at && { label: `Approved by ${craftsman.approved_by || "admin"}`, time: craftsman.approved_at, icon: <FaCheckCircle /> },
    craftsman.last_login && { label: "Logged in", time: craftsman.last_login, icon: <FaClock /> },
  ].filter(Boolean);

  const TABS = [
    { key: "profile",     label: "Profile",     icon: <FaUserCircle size={12} /> },
    { key: "portfolio",   label: "Portfolio",    icon: <FaImages size={12} /> },
    { key: "marketplace", label: "Marketplace",  icon: <FaShoppingBag size={12} /> },
    { key: "verification",label: "Verification", icon: <FaShieldAlt size={12} /> },
    { key: "activity",    label: "Activity",     icon: <FaHistory size={12} /> },
  ];

  const handleSaveNotes = async () => {
    if (!onSaveNotes) return;
    setSavingNotes(true);
    try { await onSaveNotes(craftsman.id, notes); }
    finally { setSavingNotes(false); }
  };

  return (
    <div className="cd-wrap">
      <style>{S}</style>

      <button className="cd-back" onClick={onBack}>
        <FaArrowLeft size={12} /> Back to list
      </button>

      {/* ── HEADER ── */}
      <div className="cd-header">
        <div className="cd-header-left">
          {imgSrc ? (
            <img src={imgSrc} alt={craftsman.full_name} className="cd-avatar" onError={e => { e.target.style.display = "none"; }} />
          ) : (
            <div className="cd-avatar-fallback">{getInitial(craftsman.full_name)}</div>
          )}
          <div>
            <span className={`cd-status-badge ${statusClass}`}>{statusLabel}</span>
            <div className="cd-name">{craftsman.company_name || craftsman.full_name || "—"}</div>
            <div className="cd-meta-row">
              {(craftsman.phone || craftsman.phone_number) && (
                <span className="cd-meta-item"><FaPhone size={11} /> {craftsman.phone || craftsman.phone_number}</span>
              )}
              {(craftsman.email || craftsman.user?.email) && (
                <span className="cd-meta-item"><FaEnvelope size={11} /> {craftsman.email || craftsman.user?.email}</span>
              )}
              {craftsman.date_joined && (
                <span className="cd-meta-item"><FaCalendarAlt size={11} /> Joined {timeSince(craftsman.date_joined)}</span>
              )}
              <span className="cd-meta-item"><FaClock size={11} /> Last login: {timeSince(craftsman.last_login) || "Never"}</span>
            </div>
          </div>
        </div>

        <div className="cd-header-actions">
          {isPending ? (
            <>
              <button className="cd-btn cd-btn-approve" disabled={hasIssues} onClick={() => onApprove(craftsman)}>
                <FaCheck size={12} /> Approve
              </button>
              <button className="cd-btn cd-btn-reject" onClick={() => onReject(craftsman)}>
                <FaTimes size={12} /> Reject
              </button>
              <button className="cd-btn cd-btn-edit" onClick={() => onEdit(craftsman)}>
                <FaEdit size={12} /> Edit
              </button>
            </>
          ) : (
            <>
              <button className="cd-btn cd-btn-edit" onClick={() => onEdit(craftsman)}>
                <FaEdit size={12} /> Edit
              </button>
              <button className="cd-btn cd-btn-suspend" onClick={() => onSuspend(craftsman)}>
                <FaBan size={12} /> {craftsman.is_active ? "Suspend" : "Reactivate"}
              </button>
              <button className="cd-btn cd-btn-delete" onClick={() => onDelete(craftsman)}>
                <FaTrash size={12} /> Delete
              </button>
            </>
          )}
        </div>
      </div>

      {/* ── COMPLETION + MISSING REQUIREMENTS (pending only) ── */}
      {isPending && (
        <div className="cd-completion-card">
          <div className="cd-completion-top">
            <span className="cd-completion-title">Profile Completion</span>
            <span className="cd-completion-pct">{completionPct}%</span>
          </div>
          <div className="cd-completion-track">
            <div className="cd-completion-fill" style={{ width: `${completionPct}%` }} />
          </div>

          <div className="cd-req-grid">
            {REQUIREMENTS.map(r => (
              <div key={r.key} className={`cd-req-item ${r.ok ? "ok" : "miss"}`}>
                {r.ok ? <FaCheckCircle size={13} /> : <FaTimesCircle size={13} />}
                {r.label}
              </div>
            ))}
          </div>

          {hasIssues && (
            <div className="cd-reason-box">
              <div className="cd-reason-title">Reason cannot be approved</div>
              {errors.map((e, i) => <div key={i} className="cd-reason-item">• Missing {e.replace(" missing", "").replace(" required", "")}</div>)}
            </div>
          )}
        </div>
      )}

      {/* ── TABS ── */}
      <div className="cd-tabs">
        {TABS.map(t => (
          <button key={t.key} className={`cd-tab${tab === t.key ? " on" : ""}`} onClick={() => setTab(t.key)}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {/* ── PROFILE ── */}
      {tab === "profile" && (
        <div className="cd-panel">
          <div className="cd-field-grid">
            <div>
              <div className="cd-field-label">Business Name</div>
              <div className="cd-field-val">{craftsman.company_name || "—"}</div>
            </div>
            <div>
              <div className="cd-field-label">Owner Name</div>
              <div className="cd-field-val">{craftsman.full_name || "—"}</div>
            </div>
            <div>
              <div className="cd-field-label">County</div>
              <div className="cd-field-val">{craftsman.county || craftsman.location || "—"}</div>
            </div>
            <div>
              <div className="cd-field-label">Town</div>
              <div className="cd-field-val">{craftsman.town || "—"}</div>
            </div>
            <div>
              <div className="cd-field-label">Years of Experience</div>
              <div className="cd-field-val">{craftsman.experience_level || craftsman.years_experience || "—"}</div>
            </div>
            <div>
              <div className="cd-field-label">Account Type</div>
              <div className="cd-field-val">{craftsman.account_type || "Individual"}</div>
            </div>

            <div style={{ gridColumn: "1 / -1" }}>
              <div className="cd-field-label">Services</div>
              <div>
                {services.length > 0
                  ? services.map(s => <span key={s} className="cd-service-chip">{s}</span>)
                  : <span style={{ color: "#666" }}>No services listed</span>
                }
              </div>
            </div>

            <div className="cd-bio">
              <div className="cd-field-label">Bio</div>
              {craftsman.description || <span style={{ color: "#666" }}>No bio provided.</span>}
            </div>
          </div>
        </div>
      )}

      {/* ── PORTFOLIO ── */}
      {tab === "portfolio" && (
        <div className="cd-panel">
          {galleryImages.length === 0 ? (
            <div className="cd-gallery-empty">No portfolio images uploaded yet.</div>
          ) : (
            <div className="cd-gallery">
              {galleryImages.map((img, i) => (
                <img key={i} src={getImageUrl(img)} alt={`Work sample ${i + 1}`} />
              ))}
            </div>
          )}
        </div>
      )}

      {/* ── MARKETPLACE ── */}
      {tab === "marketplace" && (
        <div className="cd-panel">
          <div className="cd-stat-grid">
            {[
              { lbl: "Orders Completed", val: craftsman.orders_completed ?? 0, ic: <FaCheckCircle /> },
              { lbl: "Active Orders",    val: craftsman.active_orders ?? 0,    ic: <FaShoppingBag /> },
              { lbl: "Cancelled Orders", val: craftsman.cancelled_orders ?? 0, ic: <FaTimesCircle /> },
              { lbl: "Average Rating",   val: craftsman.rating ? craftsman.rating.toFixed(1) : "—", ic: <FaStar /> },
              { lbl: "Total Reviews",    val: craftsman.review_count ?? 0,     ic: <FaStar /> },
              { lbl: "Total Earnings",   val: `KSh ${(craftsman.total_earnings ?? 0).toLocaleString()}`, ic: <FaMoneyBillWave /> },
            ].map((s, i) => (
              <div key={i} className="cd-stat">
                <div className="cd-stat-icon">{s.ic}</div>
                <div className="cd-stat-val">{s.val}</div>
                <div className="cd-stat-lbl">{s.lbl}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── VERIFICATION ── */}
      {tab === "verification" && (
        <div className="cd-panel">
          {[
            ["Approved By",  craftsman.approved_by || "—"],
            ["Approved On",  craftsman.approved_at ? timeSince(craftsman.approved_at) : "—"],
            ["Verification Status", craftsman.proof_document ? "Document uploaded" : "No document uploaded"],
          ].map(([key, val]) => (
            <div key={key} className="cd-verif-row">
              <span className="cd-verif-key">{key}</span>
              <span className="cd-verif-val">{val}</span>
            </div>
          ))}

          <div className="cd-notes-box">
            <div className="cd-field-label" style={{ marginBottom: 8 }}>Admin Notes</div>
            <textarea
              className="cd-notes-textarea"
              placeholder="Internal notes about this craftsman — verification concerns, support history, etc."
              value={notes}
              onChange={e => setNotes(e.target.value)}
            />
            {onSaveNotes && (
              <button
                className="cd-btn cd-btn-edit"
                style={{ marginTop: 10 }}
                onClick={handleSaveNotes}
                disabled={savingNotes}
              >
                {savingNotes ? "Saving…" : "Save Notes"}
              </button>
            )}
          </div>
        </div>
      )}

      {/* ── ACTIVITY ── */}
      {tab === "activity" && (
        <div className="cd-panel">
          {activity.length === 0 ? (
            <div className="cd-timeline-empty">No activity recorded yet.</div>
          ) : (
            <div className="cd-timeline">
              {activity.map((a, i) => (
                <div key={i} className="cd-timeline-item">
                  <div className="cd-timeline-dot">{a.icon}</div>
                  <div>
                    <div className="cd-timeline-label">{a.label}</div>
                    <div className="cd-timeline-time">{timeSince(a.time) || "—"}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
